export type PetAsset = {
  id: string;
  src: string;
  srcSm: string;
  /** Intrinsic size of `srcSm`. Rendering an `<img>` without it costs a second
      layout pass per cutout, and Lighthouse fails `unsized-images` for it. */
  width: number;
  height: number;
  /** Intrinsic width of `src`, so a stage drawn wider than `srcSm` can pick it. */
  fullWidth: number;
  species: 'dog' | 'cat';
  sourceUrl: string;
};

export const dogAssets: PetAsset[] = [
  {
    id: 'dog-01',
    src: '/images/dog-01.webp',
    srcSm: '/images/dog-01-sm.webp',
    fullWidth: 793,
    width: 600,
    height: 908,
    species: 'dog',
    sourceUrl: 'https://pngimg.com/uploads/dog/dog_PNG50354.png',
  },
  {
    id: 'dog-02',
    src: '/images/dog-02.webp',
    srcSm: '/images/dog-02-sm.webp',
    fullWidth: 667,
    width: 400,
    height: 600,
    species: 'dog',
    sourceUrl: 'https://pngimg.com/uploads/dog/dog_PNG50329.png',
  },
  {
    id: 'dog-03',
    src: '/images/dog-03.webp',
    srcSm: '/images/dog-03-sm.webp',
    fullWidth: 673,
    width: 404,
    height: 600,
    species: 'dog',
    sourceUrl: 'https://pngimg.com/uploads/dog/dog_PNG50366.png',
  },
  {
    id: 'dog-04',
    src: '/images/dog-04.webp',
    srcSm: '/images/dog-04-sm.webp',
    fullWidth: 1000,
    width: 600,
    height: 399,
    species: 'dog',
    sourceUrl: 'https://pngimg.com/uploads/dog/dog_PNG50386.png',
  },
  {
    id: 'dog-05',
    src: '/images/dog-05.webp',
    srcSm: '/images/dog-05-sm.webp',
    fullWidth: 1000,
    width: 600,
    height: 347,
    species: 'dog',
    sourceUrl: 'https://pngimg.com/uploads/dog/dog_PNG50388.png',
  },
  {
    id: 'dog-07',
    src: '/images/dog-07.webp',
    srcSm: '/images/dog-07-sm.webp',
    fullWidth: 793,
    width: 476,
    height: 600,
    species: 'dog',
    sourceUrl: 'https://pngimg.com/uploads/dog/dog_PNG50341.png',
  },
  {
    id: 'dog-08',
    src: '/images/dog-08.webp',
    srcSm: '/images/dog-08-sm.webp',
    fullWidth: 1000,
    width: 600,
    height: 391,
    species: 'dog',
    sourceUrl: 'https://pngimg.com/uploads/dog/dog_PNG50347.png',
  },
];

export const catAssets: PetAsset[] = [
  {
    id: 'cat-01',
    src: '/images/cat-01.webp',
    srcSm: '/images/cat-01.webp',
    fullWidth: 862,
    width: 862,
    height: 1000,
    species: 'cat',
    sourceUrl: 'https://pngimg.com/uploads/cat/cat_PNG50483.png',
  },
  {
    id: 'cat-02',
    src: '/images/cat-02.webp',
    srcSm: '/images/cat-02-sm.webp',
    fullWidth: 410,
    width: 246,
    height: 600,
    species: 'cat',
    sourceUrl: 'https://pngimg.com/uploads/cat/cat_PNG50466.png',
  },
  {
    id: 'cat-03',
    src: '/images/cat-03.webp',
    srcSm: '/images/cat-03-sm.webp',
    fullWidth: 848,
    width: 509,
    height: 600,
    species: 'cat',
    sourceUrl: 'https://pngimg.com/uploads/cat/cat_PNG50430.png',
  },
  {
    id: 'cat-04',
    src: '/images/cat-04.webp',
    srcSm: '/images/cat-04-sm.webp',
    fullWidth: 1000,
    width: 600,
    height: 347,
    species: 'cat',
    sourceUrl: 'https://pngimg.com/uploads/cat/cat_PNG50540.png',
  },
  {
    id: 'cat-05',
    src: '/images/cat-05.webp',
    srcSm: '/images/cat-05-sm.webp',
    fullWidth: 1000,
    width: 600,
    height: 569,
    species: 'cat',
    sourceUrl: 'https://pngimg.com/uploads/cat/cat_PNG50550.png',
  },
];

export const allPetAssets = [...dogAssets, ...catAssets];

export const petAssetById = Object.fromEntries(allPetAssets.map((asset) => [asset.id, asset])) as Record<
  string,
  PetAsset
>;

export const careModePetIds = {
  companion: 'dog-03',
  feline: 'cat-02',
  urgent: 'dog-07',
} as const;
